// Presentation identity only. The immutable strategy definition owns this family;
// activity and market state remain separate backend authorities.
const FAMILIES = Object.freeze({
  'trend-pullback': { key: 'trend', label: 'Trend Retracement', mark: 'rise', expression: 'steady' },
  'momentum-breakout': { key: 'momentum', label: 'Momentum Breakout', mark: 'spark', expression: 'eager' },
  'controlled-mean-reversion': { key: 'reversion', label: 'Controlled Mean Reversion', mark: 'return', expression: 'soft' },
  'moving-average-crossover': { key: 'crossover', label: 'Moving Average Crossover', mark: 'cross', expression: 'focused' },
  'bearish-breakdown': { key: 'breakdown', label: 'The Big Short', mark: 'down', expression: 'focused' },
  'trend-pullback-v2-experimental': { key: 'experiment', label: 'Trend Confirmation', mark: 'double-rise', expression: 'eager' },
});

// Classic Technical is retained only for existing observer-v1 definitions.
const CLASSIC = Object.freeze({ key: 'classic', label: 'Classic Technical', mark: 'dial', expression: 'steady' });
const CUSTOM = Object.freeze({ key: 'custom', label: 'Custom strategy', mark: 'hex', expression: 'steady' });

export const botPersonality = (bot = {}) => {
  const family = String(bot.trading_strategy_family || '').trim();
  const design = FAMILIES[family] || (bot.evaluator_version === 'observer-v1' ? CLASSIC : CUSTOM);
  // The small antenna variation is stable across pages and never changes the family cue.
  const id = Number(bot.id ?? bot.bot_id);
  const variant = Number.isSafeInteger(id) && id >= 0 ? id % 3 : 0;
  return { ...design, variant };
};

export const governedBotPersonalityFamilies = Object.freeze(Object.keys(FAMILIES));
